export default __webpack_public_path__ + "static/media/loader-table.868a6998.gif";